import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import Ball from "../assets/img/custom/balls.png";
import SignUpImg from "../assets/img/custom/SignupImg.jpg";
import SignUpImgId from "../assets/img/custom/schoolAndAthleteRegistration.jpg";
import routes from "routes.js";

const Auth = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const isEmailVerification = location.pathname === "/auth/email-verification-pending";

  return (
    <>
      <div ref={mainContent}>
        <Container fluid>
          <Row className="auth-right">
            <Col lg={isEmailVerification ? 12 : 5} className="bg-white-1">
              <Switch>
                {getRoutes(routes)}
                <Redirect from="*" to="/auth/login" />
              </Switch>
            </Col>
            {!isEmailVerification && (
              <Col lg={7} className="bg-secondary">
              <div>
                <h2 className="text-dark auth-desc-title">FANS HELP PLAYERS</h2>
                <p className="text-dark auth-desc-subtitle">
                  All offers herein are void where prohibited by law or if in
                  conflict with school/conference NIL (name, image, and
                  likeness) guidelines or regulations.
                </p>
                {/* <p className='text-dark auth-desc-points'>
									1- Players all get signed up right here. And
									Fans, we each find our favorite player by
									verifying via athlete’s social media.
									<br />
									<br />
									2- Then a Fan buys a badge (Price as fan
									chooses - $4 to $1000).
									<br />
									<br />
									3- Fan downloads their endorsement badge and
									posts it on their social media page or
									prints badge out for framing.
									<br />
									<br />
									4- Buyer on honor system to remove badge
									from social media after license expires.
									<br />
									<br />
									5- Each dollar of price gives one week on
									license. Example, price of $4 means license
									expires after 4 weeks from purchase.
									<br />
									<br />
									6. Fan can request a call with their
									favorite athlete, as non-paid Skype call or
									a call on Pay-by-minute line to be educated
									by athlete Brand Ambassador on details of
									FHP Brand and website use.
								</p> */}
                <div className="text-center mb-3 d-none d-sm-block">
                  <Row className="justify-content-center">
                    <Col md="8">
                      <img src={Ball} alt="balls" width="100%" />
                    </Col>
                  </Row>

                  {location.pathname === "/auth/register" && (
                    <Row className="justify-content-center mt-5">
                      <Col md="11">
                        <img src={SignUpImg} alt="Sign Up" width="100%" />
                      </Col>
                      {/* <Col md="11">
                        <img src={SignUpImgId} alt="Sign Up" width="100%" />
                      </Col> */}
                    </Row>
                  )}
                </div>
              </div>
            </Col>
            )}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Auth;
